define('Store.Cart.StateObserver', [
	'Backbone',
	'jQuery',
	'LiveOrder.Model',
	'Session',
	'Store.LiveOrder.Helper',
	'Store.Selector.ConfirmationModal',
	'underscore',
	'UrlHelper',
	'Utilities.CookieJar',
	'Utils'
], function StoreCartStateObserver(
	Backbone,
	jQuery,
	LiveOrderModel,
	Session,
	LiveOrderHelper,
	StoreSelectorConfirmationModal,
	_,
	UrlHelperModule,
	CookieJar,
	Utils
) {
	var UrlHelper = UrlHelperModule.UrlHelper || UrlHelperModule;

	function isCurrentViewCheckout(application) {
		return application
			&& application.getLayout().currentView
			&& application.getLayout().currentView.attributes
			&& application.getLayout().currentView.attributes.id === 'checkout';
	}

	return {
		hookRedirectListener: function hookRedirectListener(application) {
			var cartPromise = jQuery.Deferred();
			var layout = application.getComponent('Layout');
			var cart = application.getComponent('Cart');

			if (application.name === 'Checkout') {
				LiveOrderModel.loadCart().done(function onAfterCartLoad() {
					cartPromise.resolve();
				});
				application.getLayout().on('beforeAppendView', function onBeforeAppendView() {
					jQuery.when(cartPromise).then(function onCheckoutReady() {
						var cartTouchpoint;
						var isReady = LiveOrderHelper.isReadyToCheckout();
						var isViewCheckout = isCurrentViewCheckout(application);

						if (!isReady && isViewCheckout) {
							cartTouchpoint = Session.get('touchpoints.viewcart');
							window.location = cartTouchpoint;
						}
					});
				});
			}

			layout.on('afterShowContent', function () {
				var isReady = LiveOrderHelper.isReadyToCheckout(); // keep old functionality
				var cartTouchpoint;

				cart.getLines().then(function (lines) {
					var notPurchaseable = _.filter(lines, function (line) {
						return !line.item.extras.keyMapping_isPurchasable;
					});

					if (CookieJar.getItem('needsCartCheck') === 'true' && application.name !== 'Checkout') {
						CookieJar.removeItem('needsCartCheck');
						if (!isReady || notPurchaseable.length > 0 || LiveOrderHelper.hasPriceChanged()) {
							if (application.name === 'Shopping') {
								if (layout && Backbone.history.getFragment() !== 'cart') {
									layout.showContent(StoreSelectorConfirmationModal, {
										showInModal: true,
										options: {
											className: 'store-confirmation-modal'
										}
									});
								}
							} else {
								_.defer(function deferRefresh() {
									cartTouchpoint = Session.get('touchpoints.viewcart');
									window.location = cartTouchpoint;
								});
							}
						}
					}
				});
			});
		}
	};
});
